document.addEventListener('DOMContentLoaded', async () => {
  const upsellsInjector = new UpsellsInjector();
  upsellsInjector.init(document.querySelector('.upsells-inject'), null, 3);
  upsellsInjector.renderUpsells();


  const originalFetch = window.fetch;

  window.fetch = async function(url, options) {
    let rerender_upsells = false;
    let product_id = null;
    const response = await originalFetch.apply(this, arguments);
    if (url.includes('/cart/add')) {
      if (options && options.body instanceof FormData) {
        for (let pair of options.body.entries()) {
          if (pair[0] === 'product-id') {
            rerender_upsells = true;
            product_id = pair[1];
            //console.log("Product added to cart: ", product_id);
            break;
          }
        }
      }
    }
    if (rerender_upsells) {
      const upsellsInjector = new UpsellsInjector();
      upsellsInjector.init(document.querySelector('.upsells-inject'), product_id, 1);
      upsellsInjector.renderUpsells();
    }
    return response;
  };

});

class UpsellsInjector {
  constructor() {
    this.hookPoint = null;
    this.limit = 3;
    this.product_id = null; // Test ID: 7806045716700
  }

  async init(hookPoint, product_id, limit) {
    if (!hookPoint) return;
    this.hookPoint = hookPoint;

    if (product_id) this.product_id = product_id;
    if (limit) this.limit = limit;

    if (!product_id) {
      await this.getCart().then(cart => {
        if (cart.length) {
          //console.log("Cart: ", cart);
          this.product_id = cart[0].product_id;
          this.renderUpsells();
        }
      });
    } else {
      await this.renderUpsells();
    }

    this.applyEventListeners();
  }

  getUpsells(product_id) {
    const id = product_id || this.product_id;

    if (!id) {
      return Promise.resolve([]);
    }

    return fetch(`/recommendations/products.json?product_id=${id}&limit=${this.limit}`)
      .then(response => response.json())
      .then(data => {
        return data.products;
      })
  }

  async renderUpsells() {
    //console.log("Rendering upsells...", this.product_id);
    const products = await this.getUpsells(this.product_id);
    if (!products?.length) return;

    // Create the main container
    const upsellsContainer = document.createElement('div');
    upsellsContainer.classList.add('upsells-container');

    // Create a header with toggle functionality
    const upsellsHeader = document.createElement('div');
    upsellsHeader.classList.add('upsells-header');

    const upsellsTitle = document.createElement('h4');
    upsellsTitle.textContent = 'Related Products';
    upsellsTitle.classList.add('upsells-title');

    const toggleButton = document.createElement('button');
    toggleButton.innerHTML = '<span class="toggle-icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-chevron-down-icon lucide-chevron-down"><path d="m6 9 6 6 6-6"/></svg></span>';
    toggleButton.classList.add('upsells-toggle');
    toggleButton.setAttribute('aria-label', 'Toggle related products');

/*
    upsellsHeader.appendChild(upsellsTitle);
*/
    upsellsHeader.appendChild(toggleButton);

    // Create the content container
    const upsellsContent = document.createElement('div');
    upsellsContent.classList.add('upsells-content');

    // Add products to the content container
    products.forEach(product => {
      const productCard = this.createProductCard(product);
      upsellsContent.appendChild(productCard);
    });

    // Add event listener to toggle button
    toggleButton.addEventListener('click', () => {
      upsellsContainer.classList.toggle('collapsed');
    });

    // Add components to main container
    upsellsContainer.appendChild(upsellsHeader);
    upsellsContainer.appendChild(upsellsContent);

    /* Replaces the content of the hook point with the upsells container */
    if (this.hookPoint) {
      this.hookPoint.innerHTML = '';
      this.hookPoint.appendChild(upsellsContainer);
      return true;
    }
    return false;
  }

  createProductCard(product) {
    if (!product) return null;

    //console.log("Product: ", product);

    const productCard = document.createElement('div');
    productCard.classList.add('product-card');

    const productImage = document.createElement('img');
    productImage.src = product.images[0];
    productImage.alt = product.title;
    productImage.width = 200;
    productImage.height = 200;
    productImage.loading = 'lazy';
    productImage.classList.add('product-image');

    const productContentWrapper = document.createElement('div');
    productContentWrapper.classList.add('product-content-wrapper');

    const productTitle = document.createElement('h3');
    productTitle.textContent = product.title;
    productTitle.classList.add('product-title');

    const productPrice = document.createElement('span');
    productPrice.textContent = `${this.formatMoney(product.price)}`;
    productPrice.classList.add('product-price');

    const productButton = document.createElement('button');
    productButton.textContent = '+Tilføj';
    productButton.classList.add('product-button');
    productButton.setAttribute('data-variant-id', product.variants[0].id);
    productButton.setAttribute('leveringstid', this.getDeliveryTime(product));
    productButton.addEventListener('click', () => {
      this.addToCart(product.variants[0].id, { 'leveringstid': this.getDeliveryTime(product) });
    });

    productCard.appendChild(productImage);
    productContentWrapper.appendChild(productTitle);
    productContentWrapper.appendChild(productPrice);
    productCard.appendChild(productContentWrapper);
    productCard.appendChild(productButton);

    return productCard;
  }

  getDeliveryTime(product) {
    // leveringstid_Bestillingsvare 4-8 uger
    if (product.tags.length > 0) {
      const tag = product.tags.find(tag => tag.includes('leveringstid_Bestillingsvare'));
      if (tag) return tag.split('_')[1].replace('Bestillingsvare ', '');
    }
    return '';
  }

  getCart() {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(data => {
        return data.items;
      })
  }

  applyEventListeners() {
    const productButtons = document.querySelectorAll('.product-button');
    productButtons.forEach(button => {
      button.addEventListener('click', () => {
        const variant_id = button.getAttribute('data-variant-id');
        this.addToCart(variant_id, { 'leveringstid': button.getAttribute('leveringstid') });
      });
    });
  }

  addToCart(variant_id, properties = {}) {
    if (!variant_id) return;

    const formData = {
      'items': [
        {
          'id': variant_id,
          'quantity': 1,
          'properties': properties
         }
      ]
     };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      return response.json();
    })
    .then(data => {
      /* console.log('Success:', data); */
      const productButton = document.querySelector(`.product-button[data-variant-id="${variant_id}"]`);
      productButton.textContent = 'Tilføjet';
      productButton.disabled = true;

      setTimeout(() => {
        productButton.closest('.product-card').remove();
      }, 3000);

      const event = new Event('updateCartDrawer');
      window.dispatchEvent(event);

      // Add this line to update the free shipping bar
      fetchCartAndUpdate();
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  formatMoney(cents) {
    return (cents / 100).toLocaleString('da-DK', {
        style: 'currency',
        currency: 'DKK'
    });
  }
}
